import type { TrackingEvent } from '@marketplace-web/shared/event-tracker-data'

type viewUserEventArgs = {
  path: string
  user_id: number
}

export const viewUserEvent = (args: viewUserEventArgs): TrackingEvent => {
  const { path, user_id } = args

  const extra = {
    path,
    user_id,
  }

  return {
    event: 'user.view_user',
    extra,
  }
}
